import React from 'react';
import _ from 'lodash';
import View from 'components/ui/view';
import Text from 'components/ui/text';
import LocationIcon from 'images/icons/location-outline-small.svg?react-svg';

export default function OrderAddress({ order }) {
  const giftRecipient = order.gift_info.recipient;
  const giftMessage = order.gift_info.message;
  const { address, unit, zip } = order.delivery_address_detail;
  const displayAddress = [address, unit, zip]
    .filter(str => !_.isEmpty(str))
    .join(', ');
  const deliveryNotes = order.delivery_notes;

  return (
    <View className="order-history-row" padding="sm">
      <div className="order-history-row__icon-container">
        <LocationIcon />
      </div>
      <View
        className="order-history-row__address-container"
        inlineBlock
        padding={{ sides: 'sm' }}
      >
        {giftRecipient && (
          <div className="text-overflow">
            <Text tag="span" weight="med">
              {giftRecipient}
            </Text>
            {giftMessage && ' -'}
            {giftMessage && <span className="quote-text">{giftMessage}</span>}
          </div>
        )}
        <div className="text-overflow">{displayAddress}</div>
        {deliveryNotes && (
          <div className="quote-text text-overflow">{deliveryNotes}</div>
        )}
      </View>
    </View>
  );
}
